export default {
  meta: {
    title: 'AI陪练',
    url: '/abside/training', // 埋点字段，上报归属的模块
    urlName: 'ab侧-AI陪练', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
